import styles from './editorialHeader.scss';
import { EditorialLogo } from 'components/Editorials/themes/BGH/EditorialLogo';

export const EditorialHeader = () => (
  <div className={styles.imageWrapper}>
    <EditorialLogo />
  </div>
);
